<template>
    <div v-if="open">
        <Window :id="'AddNewAccount'" :title="title" ref="Window">
            <div slot="headButton" class="fR cb tra-fast_E ml05x_E">
                <button class="bdSub boxR hover-bg-highLight" @click="Close">{{$t('cmd85',['取消'])}}</button>
                <!-- <button @click="nextSetp" type="button" class="functionBtn" :class="{disable:!isNextStep}" v-if="step==1">{{$t('cmd11',['下一步'])}}</button> -->
                <button @click="save" type="button" class="functionBtn" :class="{disable:!isSave}">{{$t('cmd84',['保存'])}}</button>
            </div>
            <div  fillHeight="window,-#newFirmware .head"
         scroll>
         <div class="w60pct mc mt4x posR">
                <!-- <div class="w20x stepSys mc">
                    <div class="tableSys">
                        <div class="step" :class="{active:step==1}">
                            <div><span class="num">1</span><div class="name">{{$t('phrase678',['完善账号信息'])}}</div></div>
                        </div>
                        <div></div>
                        <div class="step" :class="{active:step==2}">
                            <div><span class="num">2</span><div class="name">{{$t('phrase679',['完善商家信息'])}}</div></div>
                        </div>
                    </div>
                    <div class="stepBar" :step="Math.floor(100/3)*0"></div>
                </div> -->
                <ul class="w44pct_E dpIB_E mt2x_E vaT_E" v-if="step==1">
                    <li style="width:100%" class="curP_E">
                       <MyRadio class="dpIB mr2x" name="account" v-model="result.type" label="email" >{{getLanguageStr("word1577","用邮箱作为账号")}}</MyRadio>
                       <MyRadio class="dpIB mr2x" name="account" v-model="result.type" label="phone" >{{getLanguageStr("word1576","用手机号作为账号")}}</MyRadio>

                        <!-- <label class="mr4x"><input type="radio" v-model="result.type" :value="'phone'" name="account">{{getLanguageStr('手机号作为账号','手机号作为账号')}}</label>
                        <label><input type="radio" v-model="result.type" :value="'email'" name="account">{{getLanguageStr('邮箱作为账号','邮箱作为账号')}}</label> -->
                    </li>
                    <li>
                        <div class="cSub mb1x" :title="getLanguageStr('word67','姓名')"><span class="cWarning">* </span>{{getLanguageStr('word67','姓名')}}</div>
                        <InputText   class="w100pct" v-model="result.name" name="accountName" :verification="'notEmpty'"></InputText>
                    </li>
                    <li class="ml10pct">
                        <div class="cSub mb1x" :title="result.type=='phone'?getLanguageStr('word1337','登录手机号'):getLanguageStr('phrase178','登录邮箱')"><span class="cWarning">* </span>{{result.type=='phone'?getLanguageStr('word1337','登录手机号'):getLanguageStr('phrase178','登录邮箱')}}</div>
                        <InputPhone @UpdatePhonePrefix="v=>{phonePrefix.active=v}" @UpdatePhoneNumber="v=>{result.phoneNumber=v}" name="phoneNumber" v-show="result.type=='phone'" :addClass="'sizeM pl7x'"></InputPhone>
                        <InputText class="w100pct" v-model="result.email" name="email" :verification="'notEmpty,isEmail'" v-show="result.type !=='phone'"></InputText>
                    </li>
                    <li>
                        <div class="cSub mb1x" :title="getLanguageStr('word1633','登录用户名')">{{getLanguageStr('word1633','登录用户名')}}</div>
                        <!--  :verification="'isUsername'" -->
                        <InputText :only="'username'" class="w100pct" v-model="result.username" name="username"></InputText>
                    </li>
                    <li class="ml10pct">
                        <div class="cSub mb1x" :title="getLanguageStr('word672','初始密码')">{{getLanguageStr('word672','初始密码')}}</div>
                        <InputText class="w100pct" :disabled='true' v-model="result.password" name="password" :placeholder="getLanguageStr('word672','初始密码')+'123456'"></InputText>
                    </li>
                </ul>
                <EditContainer class='mt2x posR pb10x' ref="EditContainer" @updateData="ContainerData"></EditContainer>
                </div>
            </div>
        </Window>
    </div>
</template>
<script>
import * as lib from '@/util/lib.js'
import {getLanguageStr} from '@/util/language.js'
import {mapGetters} from 'vuex'
import Window from '@/components/common/ui/WindowForNew.vue'
import InputText from '@/components/common/ui/InputText.vue'
import Select from '@/components/common/ui/Select.vue'
import InputPhone from '@/components/common/ui/InputPhone'
import {getOutRoles} from '@/api/manage/roleFunc.js'
import MyRadio from '@/components/common/ui/Radio'
import EditContainer from '@/view/manage/provider/components/EditContainer.vue'
import {AddNewUser, EditEntityRel, addNewBus, AddBusRole,addorg} from '@/api/manage/externalRelative.js'
import sha256 from 'sha256'
export default {
  name: 'addNewBus',
  components: {Window, InputText, Select, InputPhone, EditContainer, MyRadio},
  mounted () {
    lib.fillHeight()
    lib.setScroll($(this.$el).find('[scroll]'))
  },
  computed: {
    ...mapGetters({
      countries: 'user/countries',
      userInfos: 'user/userInfo'
    }),
    isNextStep () {
      if (this.result.type === 'phone') {
        if (this.result.phoneNumber && this.result.name) {
          return true
        } else {
          return false
        }
      } else {
        if (this.result.email && this.result.name) {
          return true
        } else {
          return false
        }
      }
    },
    isSave () {
      if (!this.result.name || (this.result.type === 'phone' && !this.result.phoneNumber) || (this.result.type === 'email' && !this.result.email)) {
        return false
      }
      if (JSON.stringify(this.containerData) != '{}') {
        let names = this.containerData.nameList.filter(el => el.name)
        if (this.containerData.RolesId && names.length == this.containerData.nameList.length) {
          return true
        } else {
          return false
        }
      }
    }
  },
  data () {
    return {
      stage,
      step: 1,
      open: false,
      title: '',
      adminId: null,
      outsideRoles: [],
      phonePrefix: {// 电话号码前缀
        active: '',
        list: []
      },
      result: {
        type: 'phone',
        name: '',
        phoneNumber: '',
        email: '',
        username: '',
        password: '',
        role: 0
      },
      containerData: {}
    }
  },
  methods: {
    getLanguageStr,
    getTypeText: lib.getTypeText,
    show () {
     
      this.reset()
      this.open = true
      // this._getRoleList()
      // if (stage.loc.accountFirstUse == 'eMail') {
      //   this.$nextTick(_ => {
      //     this.result.type = 'email'
      //   })
      // }
      if (this.userInfos.organization.areaId == 44) {
        this.$nextTick(_ => {
          this.result.type = 'phone'
        })
      } else {
        this.$nextTick(_ => {
          this.result.type = 'email'
        })
      }
      setTimeout(() => {
        this.$refs.Window.show()
        this.title = getLanguageStr('word1789', '创建新商家')
        lib.fillHeight()
        lib.setScroll($(this.$el).find('[scroll]'))
      }, 10)
    },
    reset () {
      this.step = 1
      this.open = false
      this.adminId = null
      this.phonePrefix = {
        active: '',
        list: []
      }
      this.result = {
        type: 'phone',
        name: '',
        phoneNumber: '',
        email: '',
        username: '',
        password: '',
        role: 0
      }
      this.containerData = {}
    },
    Close () {
      this.$refs.Window.hide()
      setTimeout(() => {
        this.reset()
      }, 500)
    },
    // 关联人返回
    updatePersonList () {

    },
    test () {
      this.$refs.test.show()
    },
    nextSetp () {
      if (this.result.type == 'email' && lib.validValue(this.result.email, ['notEmail']).allClear) {
        return false
      } else {
        let password
        if (this.stage.loc.loginSystem.sha256) {
          password = this.result.password ? sha256(this.result.password) : sha256('123456')
        } else {
          password = this.result.password
        }
        let request = {
          credential: password,
          userInfo: {
            countryCode: this.result.type == 'phone' ? this.phonePrefix.active : '',
            name: this.result.name,
            email: this.result.type == 'email' ? this.result.email : '',
            phoneNumber: this.result.type == 'phone' ? this.result.phoneNumber : '',
            username: this.result.username
          }
        }
        AddNewUser(request).then(res => {
          this.step = 2
          this.adminId = res
        }, error => {
          !_.isEmpty(error) && this.$notify(error)
        })
      }
    },
    ContainerData (data) {
      this.containerData = data
    },
    save () {
      let request = _.cloneDeep(this.containerData)
      request.category=this.containerData.org.category
      request.org.adminId = this.adminId
      // delete request.RolesId
      // request.nameList.forEach(el => {  
      //   delete el.idKey
      //   delete el.selectActive
      // })
      request.orgNameList = Object.assign([], request.nameList)
      let password
      if (this.stage.loc.loginSystem.sha256) {
        password = this.result.password ? sha256(this.result.password) : sha256('123456')
      } else {
        password = this.result.password
      }
      request.orgAreaId = request.org.areaId
      if(this.result.type == 'phone'){
          request.countryCode = this.phonePrefix.active
      }else{
          request.countryCode = ''
      }
      request.orgBusinessType = request.org.businessType
      request.orgType = request.org.type
      request.email = this.result.email
      request.name = this.result.name
      request.orgTimezone = request.org.timezone
      request.phoneNumber = this.result.phoneNumber
      request.username = this.result.username
      request.credential = password
      request.roleId = request.RolesId
      request.system = stage.loc.customer
      
      if (this.result.type === 'email') {
        request.phoneNumber = ''
      } else {
        request.email = ''
      }
      delete request.org;
      delete request.nameList;
      addorg(request).then(res => {
         this.Close()
        this.$emit('updateList', this.containerData, res)
      }, error => {
        !_.isEmpty(error) && this.$notify(error)
      })
      // addNewBus(request).then(res => {
      //   this.buildRel(res)
      // }, error => {
      //   !_.isEmpty(error) && this.$notify(error)
      // })
    },
    // 建立关系
    buildRel (userId) {
      let request = {
        targetEntityId: userId,
        roleId: this.containerData.RolesId,
        targetEntityType: 1
      }
      AddBusRole(request).then(res => {
        this.Close()
        this.$emit('updateList', this.containerData, res)
      }, error => {
        !_.isEmpty(error) && this.$notify(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/view/manage/account/AddNewBusiness.vue